import type { AuthUser } from './user.types';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

export interface AuthState {
  user: AuthUser | null;
  tokens: AuthTokens | null;
  isLoading: boolean;
  isAuthenticated: boolean;
}

/**
 * Login success — tokens issued. Possibly still needs a password change
 * if `passwordExpired` is true; caller should redirect to the change-password
 * page before proceeding.
 */
export interface LoginSuccess {
  accessToken: string;
  passwordExpired: boolean;
  user: AuthUser;
}

/**
 * Login step 1 succeeded but 2FA is enabled on the account.
 * No tokens are issued yet — the client must call POST /api/auth/2fa/verify-login
 * with `twoFactorToken` + a TOTP/backup code.
 */
export interface TwoFactorChallenge {
  requires2FA: true;
  twoFactorToken: string;
}

export type LoginOutcome = LoginSuccess | TwoFactorChallenge;

/** Narrowing helper for callers. */
export function isTwoFactorChallenge(outcome: LoginOutcome): outcome is TwoFactorChallenge {
  return (outcome as TwoFactorChallenge).requires2FA === true;
}
